import { createReducer } from '@reduxjs/toolkit';
import { RequestError, HistoricCommunication } from 'types';
import { saveBlob } from '../../utils/save-blob';
import {
  fetchHistoricCommunication,
  fetchedHistoricCommunication,
  exportHistoricCommunication,
  exportedHistoricCommunication,
  fetchHistoricCommunicationSenders,
  fetchedHistoricCommunicationSenders,
} from './actions';
import { State } from './types';

export const INITIAL_STATE: State = {
  status: undefined,
  error: undefined,
  data: undefined,
  senders: {
    status: undefined,
    error: undefined,
    data: [],
  },
};

// https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
export default createReducer<State>(INITIAL_STATE, (builder) =>
  builder
    .addCase(fetchHistoricCommunication, (state) => {
      state.status = 'loading';
    })
    .addCase(fetchedHistoricCommunication, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.data = undefined;
        state.status = 'error';
      } else {
        state.error = undefined;
        state.status = 'success';
        state.data = payload as HistoricCommunication;
      }
    })
    .addCase(exportHistoricCommunication, (state) => {
      state.status = 'loading';
    })
    .addCase(exportedHistoricCommunication, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.data = undefined;
        state.status = 'error';
      } else {
        const returnState = saveBlob(payload, 'historic');
        state.error = returnState.error;
        state.status = returnState.status;
      }
    })
    .addCase(fetchHistoricCommunicationSenders, (state) => {
      state.senders.status = 'loading';
    })
    .addCase(fetchedHistoricCommunicationSenders, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.senders.error = payload as RequestError;
        state.senders.status = 'error';
      } else {
        state.senders.data = payload as State['senders']['data'];
        state.senders.error = undefined;
        state.senders.status = 'success';
      }
    })
);
